import React from 'react';
import './AlarmHistory.css';
import logComponent from '../../common/logComponent';
import AlarmHistory from './AlarmHistory';
import { CardAlarmHistoryProvider } from '../../contexts/CardAlarmHistoryContext';
 
export default function AlarmHistoryCard({ moduleDescription }) {
  if (logComponent('AlarmHistoryCard')) { console.debug('AlarmHistoryCard rendered'); }


  return (
    <CardAlarmHistoryProvider>
      <AlarmHistory moduleDescription={moduleDescription} />
    </CardAlarmHistoryProvider>
  );
}